import {
  API_MY_PAGE,
  API_READ_NOTICATION,
  API_READ_NOTICATIONS,
} from "../../constants/api";
import API from "..";

export const fetchMyPage = async () => {
  try {
    const response = await API.get(API_MY_PAGE);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const readNoti = async (noti) => {
  try {
    const response = await API.post(API_READ_NOTICATION, {
      id: noti.id,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const readNotifications = async (noti) => {
  try {
    const response = await API.post(API_READ_NOTICATIONS, {
      workflow_id: noti.workflow.id,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
